import React from "react";

const SmallSpinner: React.FC = () => {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="relative h-12 w-12 animate-spin rounded-full bg-gradient-to-r from-black via-red-500 to-black">
        <div className="absolute left-1/2 top-1/2 h-10 w-10 -translate-x-1/2 -translate-y-1/2 transform rounded-full border-2 border-white bg-gray-200"></div>
      </div>
    </div>
  );
};

export default SmallSpinner;
